// TODO: check where slash is needed

// site sections
export const ROOT = '/';
export const CIRCLES = 'circles';
export const COMMUNITIES = 'communities';
export const POST = 'post';
export const HEALTHBOARD = 'healthboard';
export const HEALTHBOARD_HOME = 'home';
export const HEALTHBOARD_APPOINTMENTS = 'appointments';
export const HEALTHBOARD_APPOINTMENTS_HISTORY = 'history-appointments';
export const HEALTHBOARD_EMPTY = 'healthboard-empty';
export const HEALTHBOARD_TODO = 'todo';
export const MESSAGES = 'messaging';
export const PROFILE = 'profile';
export const PATIENT_PROFILE = 'patient';
export const PROVIDER_PROFILE = 'provider';
export const USER_PROFILE = 'user';
export const PROFILE_SETTINGS = 'settings';
export const PROFILE_PAYMENT_METHODS = 'payment-methods';
export const PROFILE_DOCUMENTATION = 'documentation';
export const PATIENT_INFO = 'patient-info';
export const PATIENT_HEALTHBOARD = 'patient-healthboard';
export const PROVIDER_INFO = 'provider-info';
export const SUPPORT = 'support';
export const PROVIDER_MEMBER_PROFILE = 'provider-member';
export const PARENT_PROVIDER = 'parent-provider';
export const FAMILY_MEMBER_PROFILE = 'family-member';
export const TEAM_MEMBER_PROFILE = 'team-member';
export const PATIENT_VIEW_PROFILE = 'patient-view';
export const CONFIRMATION = 'confirmation_expired';
export const DISCOVER = 'discover';
export const MY_COMMUNITIES = 'my-communities';
export const ORGANIZATION = 'organization';
export const ACTIVITIES = 'activities';
export const REPORTS = 'reports';
export const COMMUNITY_PREVIEW = 'community-preview';
export const PUBLIC_PROFILE = 'public-profile';
export const PUBLIC_PROFILE_INFO = ':id/info';
export const PATIENT_REGISTRATION = 'patient-registration';
export const CONTACT_INFO = 'contact-info';
export const EMERGENCY_CONTACT = 'emergency-contact';
export const ADDRESS = 'address';
export const CHOOSE_ADD_ACCOUNT = 'add-device-account';

// auth flows
export const CREATE_PASSWORD = 'reset-password/:token';
export const CHANGE_PASSWORD = 'change-password';
export const LOGIN = '/login';
export const CREATE_PATIENT_PROFILE = 'personal-details/:organizationId';
export const RESET_PASSWORD = 'reset-password';
export const ACCEPT_INVITATION = 'invitations/:token';
export const SIGNUP = 'signup';
export const CIRCLE_OF_CARE = 'circe-of-care';
export const PROGRAM = 'program';
export const PERSONAL_INFO = 'personal-info';
export const SIGN_UP_AZURE = 'signup-azure';
export const SIGNUP_INVITATION = 'signup-invitation';
export const EXPIRED_LINK = 'expired-link';
export const DEFAULT_EXPIRED_LINK = 'default-expired-link';
export const BROWSER_SUPPORT = 'browser-support';

// surveys
export const SURVEYS_GENERAL = ':id/surveys';
export const SURVEYS_GENERAL_SUB_PATH = 'surveys';

// helpers
export const ACCESS_DENIED = '/access-denied';
export const ACCESS_DENIED_COMMUNITIES = '/communities/access-denied';
export const EXPIRED_TOKEN = '/expired-token';
export const NOT_FOUND = '/not-found';

// dependent form
export const DEPENDENT_FORM = '/dependent-form';
export const DEPENDENT_FORM_COMPLETE = 'complete';
export const DEPENDENT_FORM_EXISTING = 'existing-user';
export const DEPENDENT_FORM_ROLE = 'role';
export const DEPENDENT_FORM_PERSONAL = 'personal-info';
export const DEPENDENT_FORM_GENERAL = ':id/general-info';
export const DEPENDENT_FORM_DOCUMENTS = ':id/documents';
export const DEPENDENT_FORM_RELATION = ':id/relationship';
export const APP_NOTIFICATIONS = '/app-notifications';
export const DASHBOARD = '/dashboard';
export const DASHBOARD_RECORD = '/dashboard-record';
export const DASHBOARD_VISIT_INFO = 'visit-info';

// appointment-form
export const APPOINTMENT_FORM = '/appointment-form';
export const APPOINTMENT_FORM_USERS = 'users';
export const APPOINTMENT_FORM_ORGANIZATIONS = 'organizations';
export const APPOINTMENT_FORM_PHARMACY = 'pharmacy';
export const APPOINTMENT_FORM_VISIT_TYPE = 'visit-type';
export const APPOINTMENT_FORM_HEALTH_INFO = 'health-info';
export const APPOINTMENT_FORM_PAYMENT = 'payment';
export const APPOINTMENT_FORM_SUMMARY = 'summary';
export const APPOINTMENT_FORM_VISIT_SERVICES = 'visit-services';
export const APPOINTMENT_FORM_VISIT_LOCATIONS = 'visit-locations';
export const APPOINTMENT_FORM_PUBLIX_INFO = 'publix-info';
export const APPOINTMENT_FORM_CONSENT_FORM = 'consent-form';
export const APPOINTMENT_FORM_PATIENT_INFO = 'patient-form';
export const APPOINTMENT_FORM_VISIT_DETAILS = 'visit-details';
export const APPOINTMENT_FORM_PROVIDERS = 'providers';
export const APPOINTMENT_FORM_PROVIDER_DETAILS = ':id/provider-details';
export const APPOINTMENT_FORM_OVERVIEW = 'overview';
export const APPOINTMENT_FORM_AVAILABLE_TIME_SLOTS = 'available-time-slots';
export const APPOINTMENT_FORM_MY_PROVIDERS = 'my-providers';
export const APPOINTMENT_FORM_HEALTH_INFO_PROVIDER = 'health-info-provider';
export const APPOINTMENT_FORM_EMERGENCY_CONTACT = 'emergency-contact';
export const APPOINTMENT_FORM_GUARANTOR_INFORMATION = 'guarantor-information';
export const APPOINTMENT_ADDITIONAL_INFO = 'additional-information';
export const APPOINTMENT_FORM_INSURANCE_FORM = 'insurance-form';

// paperwork
export const PAPERWORK = '/paperwork';
export const PAPERWORK_VISIT_DETAILS = 'visit-details';
export const PAPERWORK_PRIMARY_CARE_PROVIDER = 'primary-care-provider';
export const PAPERWORK_ADDITIONAL_INFORMATION = 'additional-information';
export const PAPERWORK_COMPLETE_YOUR_PROFILE = 'complete-your-profile';
export const PAPERWORK_SIGN_CONSENT = 'sign-consent';
export const PAPERWORK_SUBMIT = 'submit';
export const PAPERWORK_INSURANCE_DETAILS = 'insurance-details';
export const PAPERWORK_COMPLETE_VISIT_DETAILS = 'complete-visit-details';
export const PAPERWORK_GUARANTOR_INFORMATION = 'guarantor-information';
export const PAPERWORK_PREFERRED_PHARMACY = 'preferred-pharmacy';

export const PROVIDER_CALENDAR = '/:id/:providerId/schedule';
export const CALENDAR_MOB = '/mobile-calenar';

export const VIRTUAL_ROOM = '/virtual_room';
export const CONNECTION_ROOM = '/connection_room';
export const IN_OFFICE_VISIT = '/in-office-visit';

export const VIRTUAL_VISIT = '/virtual-visit';
export const DETAILS = 'details';
export const APPOINTMENTS = '/appointments';

export default {
  PATIENT_REGISTRATION,
  ACCEPT_INVITATION,
  ACCESS_DENIED,
  ACCESS_DENIED_COMMUNITIES,
  CIRCLES,
  COMMUNITIES,
  POST,
  CREATE_PASSWORD,
  CREATE_PATIENT_PROFILE,
  EXPIRED_TOKEN,
  HEALTHBOARD,
  HEALTHBOARD_HOME,
  HEALTHBOARD_APPOINTMENTS,
  HEALTHBOARD_APPOINTMENTS_HISTORY,
  HEALTHBOARD_EMPTY,
  HEALTHBOARD_TODO,
  MESSAGES,
  LOGIN,
  PERSONAL_INFO,
  PROFILE,
  PATIENT_PROFILE,
  PROVIDER_PROFILE,
  USER_PROFILE,
  FAMILY_MEMBER_PROFILE,
  TEAM_MEMBER_PROFILE,
  RESET_PASSWORD,
  CHANGE_PASSWORD,
  ROOT,
  SIGNUP,
  SUPPORT,
  SIGN_UP_AZURE,
  SIGNUP_INVITATION,
  SURVEYS_GENERAL,
  SURVEYS_GENERAL_SUB_PATH,
  PATIENT_VIEW_PROFILE,
  PROVIDER_MEMBER_PROFILE,
  PARENT_PROVIDER,
  CONFIRMATION,
  NOT_FOUND,
  CIRCLE_OF_CARE,
  PROFILE_SETTINGS,
  PROFILE_PAYMENT_METHODS,
  PROFILE_DOCUMENTATION,
  PATIENT_INFO,
  PATIENT_HEALTHBOARD,
  PROVIDER_INFO,
  PROGRAM,
  DISCOVER,
  MY_COMMUNITIES,
  ORGANIZATION,
  ACTIVITIES,
  REPORTS,
  COMMUNITY_PREVIEW,
  PUBLIC_PROFILE,
  PUBLIC_PROFILE_INFO,
  DEPENDENT_FORM,
  DEPENDENT_FORM_ROLE,
  DEPENDENT_FORM_PERSONAL,
  DEPENDENT_FORM_GENERAL,
  DEPENDENT_FORM_DOCUMENTS,
  DEPENDENT_FORM_RELATION,
  DEPENDENT_FORM_COMPLETE,
  DEPENDENT_FORM_EXISTING,
  APP_NOTIFICATIONS,
  DASHBOARD,
  APPOINTMENT_FORM,
  APPOINTMENT_FORM_USERS,
  APPOINTMENT_FORM_PAYMENT,
  APPOINTMENT_FORM_SUMMARY,
  APPOINTMENT_FORM_PHARMACY,
  APPOINTMENT_FORM_HEALTH_INFO,
  APPOINTMENT_FORM_ORGANIZATIONS,
  APPOINTMENT_FORM_VISIT_TYPE,
  APPOINTMENT_FORM_PUBLIX_INFO,
  APPOINTMENT_FORM_VISIT_SERVICES,
  APPOINTMENT_FORM_VISIT_LOCATIONS,
  APPOINTMENT_FORM_CONSENT_FORM,
  APPOINTMENT_FORM_PATIENT_INFO,
  APPOINTMENT_FORM_VISIT_DETAILS,
  DASHBOARD_RECORD,
  DASHBOARD_VISIT_INFO,
  APPOINTMENT_FORM_PROVIDERS,
  APPOINTMENT_FORM_MY_PROVIDERS,
  APPOINTMENT_FORM_PROVIDER_DETAILS,
  APPOINTMENT_FORM_OVERVIEW,
  VIRTUAL_ROOM,
  VIRTUAL_VISIT,
  DETAILS,
  EXPIRED_LINK,
  DEFAULT_EXPIRED_LINK,
  CONTACT_INFO,
  EMERGENCY_CONTACT,
  ADDRESS,
  BROWSER_SUPPORT,
  PROVIDER_CALENDAR,
  CALENDAR_MOB,
  CHOOSE_ADD_ACCOUNT,
  APPOINTMENTS,
  APPOINTMENT_FORM_AVAILABLE_TIME_SLOTS,
  CONNECTION_ROOM,
  IN_OFFICE_VISIT,
  APPOINTMENT_FORM_HEALTH_INFO_PROVIDER,
  APPOINTMENT_FORM_EMERGENCY_CONTACT,
  APPOINTMENT_FORM_GUARANTOR_INFORMATION,
  APPOINTMENT_ADDITIONAL_INFO,
  APPOINTMENT_FORM_INSURANCE_FORM,

  PAPERWORK,
  PAPERWORK_INSURANCE_DETAILS,
  PAPERWORK_COMPLETE_YOUR_PROFILE,
  PAPERWORK_PRIMARY_CARE_PROVIDER,
  PAPERWORK_SIGN_CONSENT,
  PAPERWORK_SUBMIT,
  PAPERWORK_VISIT_DETAILS,
  PAPERWORK_GUARANTOR_INFORMATION,
  PAPERWORK_COMPLETE_VISIT_DETAILS,
  PAPERWORK_PREFERRED_PHARMACY,
};



// WEBPACK FOOTER //
// ./src/constants/routes.js